import React, { useEffect, useCallback } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Button, colors, Grid } from '@mui/material';
import { Page, Header } from 'components';
import AddIcon from '@mui/icons-material/Add';
import FilterListIcon from '@mui/icons-material/FilterList';

import TicketsDataTable from './components/TicketsDataTable/TicketsDataTable.js';
import AddTicketDialog from './components/AddTicketDialog/AddTicketDialog.js';
import Filters from './components/Filters/Filters.js';

import { ToggleAddTicketDialog, ToggleFilters, GetTickets } from '../../actions/TicketsActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
	filterButton: {
		marginLeft: theme.spacing(1),
	},
	filterIcon: {
		marginRight: theme.spacing(1),
	},
}));

const Tickets = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const tickets = useSelector(state => state.ticketsReducer.tickets);
	const openAddTicketDialog = useSelector(state => state.ticketsReducer.openAddTicketDialog);
	const openFilters = useSelector(state => state.ticketsReducer.openFilters);

	const _addTicketClose = () => {
		dispatch(ToggleAddTicketDialog(false));
	};

	const _addTicket = () => {
		dispatch(ToggleAddTicketDialog(true));
	};

	const _handleFilterOpen = () => {
		dispatch(ToggleFilters(true));
	};

	const _handleFilterClose = () => {
		dispatch(ToggleFilters(false));
	};

	const _renderActions = () => (
		<Grid item>
			<Button color="primary" variant="contained" onClick={_addTicket}>
				<AddIcon />
				Add
			</Button>
			<Button
				className={classes.filterButton}
				color="primary"
				onClick={_handleFilterOpen}
				variant="outlined"
			>
				<FilterListIcon className={classes.filterIcon} />
				{' '}
				Show filters
			</Button>
		</Grid>
	);

	const _getData = useCallback(() => {
		dispatch(GetTickets(0, 1));
	}, []);

	useEffect(() => {
		_getData();
	}, []);

	return (
		<Page className={classes.root} title="Tickets">
			<Header module="Tickets" view="Tickets" actions={_renderActions()} />
			<div className={clsx(classes.container)}>
				<TicketsDataTable data={tickets} />
				{openAddTicketDialog && (
					<AddTicketDialog
						onClose={_addTicketClose}
						open={openAddTicketDialog}
					/>
				)}
				<Filters
					onClose={_handleFilterClose}
					open={openFilters}
				/>
			</div>
		</Page>
	);
};

export default Tickets;
